import DocumentSimplifiedDTO from "features/invoices/dtos/DocumentSimplifiedDTO";
import React from "react";
import PageCard from "features/shared/components/card/PageCard";
import DocumentDownload from "./DocumentDownload";
import { useTranslation } from "react-i18next";
import RenderWrapper from "../renderWrapper/RenderWrapper";
import ExportDefinitionSimplifiedDTO from "features/exports/dtos/ExportDefinitionSimplifiedDTO";
import ExportDownload from "./ExportDownload";

type Props = {
  documents: DocumentSimplifiedDTO[];
  exports?: ExportDefinitionSimplifiedDTO[];
  title?: string;
  expandToHeight?: boolean;
  className?: string;
  formatDocumentTitle?: (document: DocumentSimplifiedDTO) => string;
};

const DocumentDownloadCard = ({
  documents,
  exports,
  title,
  expandToHeight,
  className,
  formatDocumentTitle,
}: Props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;

  // sub-renders
  const renderDocuments = () => {
    return documents.map((item, index) => (
      <div className="py-1" key={index}>
        <DocumentDownload document={item} formatTitle={formatDocumentTitle} />
      </div>
    ));
  };

  const renderExports = () => {
    if (!exports || exports.length === 0) return null;

    return (
      <>
        {exports.map((exp, index) => (
          <div className="py-1" key={`exp-${exp.exportDefinitionId ?? index}`}>
            <ExportDownload exportDef={exp} />
          </div>
        ))}
      </>
    );
  };

  // render
  return (
    <PageCard
      title={title ?? tLabels("documentDownloadCard.cardTitle")}
      expandToHeight={expandToHeight}
      cardClassName={className}
    >
      <RenderWrapper
        isVisible={() =>
          (documents?.length ?? 0) > 0 || (exports?.length ?? 0) > 0
        }
        noVisibleRender={() => (
          <>{tLabels("documentDownloadCard.noDocuments")}</>
        )}
      >
        {renderDocuments()}
        {renderExports()}
      </RenderWrapper>
    </PageCard>
  );
};

export default DocumentDownloadCard;
